<div class="page-header">
  <div class="page-header-title">{{ 'title.user-admin' | translate }}</div>
  <div class="page-header-search flex gap-4">
    <app-search-field></app-search-field>
    <p-button icon="pi pi-plus" class="add-button add-button-white" rounded (click)="addUser()"
      [pTooltip]="'button.add-user' | translate" tooltipPosition="top" />
  </div>
</div>
<p-table
  #usersTable
  [value]="users()"
  [rows]="10"
  [paginator]="true"
  [loading]="loadingUsers"
  [style]="{ width: '100%' }"
  [paginatorDropdownAppendTo]="'body'"
  [rowsPerPageOptions]="[10, 25, 50]"
  [editingRowKeys]="editingRowKeys"
  editMode="row"
  dataKey="id"
  stripedRows
>
  <ng-template #header>
    <tr>
      <th>{{'field.username' | translate}}</th>
      <th>{{'field.roles' | translate}}</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template #body let-user let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="user">
      <!-- username -->
      <td>
        <p-cellEditor>
          <!-- TODO edit username when back ready -->
          <ng-template #input>
            <input pInputText type="text" [(ngModel)]="user.username" class="w-full" [disabled]="!_.includes(user.id, 'new-')" />
          </ng-template>
          <ng-template #output>
            {{ user.username }}
          </ng-template>
        </p-cellEditor>
      </td>
      <!-- roles -->
      <td>
        <p-cellEditor>
          <ng-template #input>
            <p-multi-select appendTo="body" [options]="roles" class="flex" [(ngModel)]="user.roles" 
              optionValue="value" optionLabel="label" display="chip">
              <ng-template let-role pTemplate="item">
                {{ role.label | translate }}
              </ng-template>
              <ng-template let-selectedRoles pTemplate="selectedItems">
                <div class="flex flex-wrap gap-1">
                  @for (role of selectedRoles; track role.value) {
                    <p-chip [label]="role.label | translate" />
                  }
                </div>
                @if (!selectedRoles?.length) {
                  <span class="text-gray-400">{{ 'field.roles' | translate }}</span>
                }
              </ng-template>
            </p-multi-select>
          </ng-template>
          <ng-template #output>
            <div class="flex gap-1">
              @for (role of user.roles; track $index)  {
                <p-tag>{{ 'roles.' + role | translate }}</p-tag>
              }
            </div>
          </ng-template>
        </p-cellEditor>
      </td>
      <!-- actions -->
      <td>
        <div class="flex items-center justify-end gap-2">
          @if(isEditing && editing) {
            <p-button pSaveEditableRow icon="pi pi-check" rounded severity="secondary"
              [pTooltip]="'button.save' | translate" tooltipPosition="top"
              [disabled]="!user.username || !user.roles?.length"
              (click)="onRowEditSave(user)"></p-button>
            <p-button pCancelEditableRow icon="pi pi-times" rounded severity="secondary"
              [pTooltip]="'button.cancel' | translate" tooltipPosition="top"
              (click)="onRowEditCancel(user, ri)"></p-button>
          }
          @if(!isEditing) {
            <p-button icon="pi pi-lock" severity="secondary" rounded
              [pTooltip]="'button.change-password' | translate" tooltipPosition="left"
              (click)="changePassword(user.id)"></p-button>
            <p-button pInitEditableRow icon="pi pi-pencil" rounded severity="secondary"
              [pTooltip]="'button.edit' | translate" tooltipPosition="top"
              (click)="onRowEditInit(user)"></p-button>
            <p-button icon="pi pi-trash" rounded severity="danger"
              [pTooltip]="'button.delete' | translate" tooltipPosition="top"
              (click)="disableUser($event, user)"></p-button>
          }
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="5">{{ 'no-item.users' | translate }}</td>
    </tr>
  </ng-template>
</p-table>

<p-confirmpopup />
